import { Component, OnDestroy, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { FormGroup, FormBuilder} from '@angular/forms';
import { NgbModalConfig, NgbModal, ModalDismissReasons, NgbCalendar, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { listProjectStage } from 'src/app/web/interfaces/project/stages/create/listProjectStage';
import { ErrorService } from 'src/app/shared/services/errors.service';

@Component({
  selector: 'app-popup-dependences',
  templateUrl: './popup-dependences.component.html',
  styleUrls: ['./popup-dependences.component.scss']
})
export class PopupDependencesComponent implements OnInit {


  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  closeResult = ''
  model2: string
  listProjectStage: listProjectStage[] = [];
  dependenceForm: FormGroup;
  type: string;
  edit: boolean;
  create: boolean;
  itemName: string;
  projectId: number;

  stageid
  selectedDependence
  probabilityName = 0;
  listAssigned: []

  constructor(
    private spinner: NgxSpinnerService,
    private config: NgbModalConfig,
    private modalService: NgbModal,
    private apiService: ApiServiceProject,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private ngbCalendar: NgbCalendar,
    private dateAdapter: NgbDateAdapter<string>,
    private errorService:ErrorService

  ) {
  }



formSubmit(): void {
    this.spinner.show();
    if (this.dependenceForm.value.dependenceId === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una dependencia' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    this.apiService
        .putService(`dependence-project-stage-update?id=${this.stageid}&id_dependence=${this.dependenceForm.value.dependenceId}`)
        .subscribe({
          next: (rs: any) => {
            if(rs.message){
              this.spinner.hide();
              Swal.fire({title:rs.message,text: '',icon: 'success',heightAuto: false}).then(()=>{location.reload()});
            }
            else{
              this.spinner.hide();
              Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
  }

  ngOnInit(): void {
   this.dependenceForm = this.fb.group({
      dependenceId: [''],
    });
  }


  serviceInfo(){
    this.spinner.show()
      this.activatedRoute.params.subscribe(params => {
        return this.projectId = params['id'];
      })
      this.spinner.show()
    this.apiService
        .getService('project-view-stage-create-info?id_project=' + this.projectId)
        .subscribe({
          next: (rs: any) => {

            if (rs.code == null) {
              // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
              if (rs == '' || rs == null) {
                this.spinner.hide();
                Swal.fire({
                  title: 'No se encontraron registros',
                  text: '',
                  icon: 'info',
                  confirmButtonText: 'Aceptar',
                  heightAuto: false
                }).then((res) => {
                  if (res.isConfirmed || res.isDismissed) {
                    this.router.navigate(['home']);
                  }
                });
              }
              this.listProjectStage = rs.listProjectStage;
              this.spinner.hide();
            } else {
              this.spinner.hide();
              Swal.fire({
              title:  rs.error,
              text: '',
              icon: 'error',
              heightAuto: false
              });
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
  }

  public open(stageid: any) { 
    this.stageid = stageid
    this.serviceInfo()
     this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    })
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  

  validField(field, form) {
    return form.controls[field].errors
      && form.controls[field].touched;
  }

  clearForm() {
   
    this.type = ''
  }



}

